import { createContext, useContext, useState, type PropsWithChildren } from 'react';

type FeaturesFlags = {
  fetch_colors: boolean;
};

type FeaturesContextType = {
  config: FeaturesFlags;
};

const FeaturesContext = createContext<FeaturesContextType | undefined>(undefined);

export function FeatureFlagsProvider({ children, initialConfig }: PropsWithChildren<{ initialConfig: FeaturesFlags }>) {
  const [config] = useState<FeaturesFlags>(() => initialConfig);

  return <FeaturesContext.Provider value={{ config }}>{children}</FeaturesContext.Provider>;
}

export function useFeature(name: keyof FeaturesFlags) {
  const context = useContext(FeaturesContext);
  if (context === undefined) {
    throw new Error('useFeatures must be used within a FeaturesProvider');
  }

  return context.config[name] ?? false;
}
